import client from "../client";
import { SendOTPUpdateBankResponse } from "./send_otp_update_bank";

interface Request {
  tel: string;
  prefix: string;
}

export default function API(
  request: Request
): Promise<SendOTPUpdateBankResponse> {
  return client
    .post(`members/send_otp_update_bank_for_register_full`, request)
    .then((response) => response.data);
}
